/**
 * Which open modal owns the keyboard (Escape, Tab trap): the most recently opened one. Every
 * modal listens on `document`, so without this two open modals would both react. Pure.
 */
export function createModalStack() {
  const open: number[] = [];
  let next = 0;
  return {
    push(): number {
      const id = ++next;
      open.push(id);
      return id;
    },
    remove(id: number): void {
      const i = open.indexOf(id);
      if (i >= 0) open.splice(i, 1);
    },
    isTop(id: number): boolean {
      return open.length > 0 && open[open.length - 1] === id;
    },
    /** No modal open — page-level keyboard shortcuts only act then. */
    isEmpty(): boolean {
      return open.length === 0;
    },
  };
}

/** The app-wide stack used by `components/common/Modal`. */
export const modalStack = createModalStack();
